import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Article from '../components/Article';
import { NewsArticle } from '../types';
import './ArticlePage.css';

const ArticlePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  // This would typically come from an API or data store
  // For now, we'll use the same data as the Home page
  const allArticles: NewsArticle[] = [
    {
      id: 'summer-2026',
      title: t('news.articles.summer2026.title'),
      excerpt: t('news.articles.summer2026.excerpt'),
      content: t('news.articles.summer2026.content'),
      publishDate: '2026-09-06',
      author: t('news.authors.forum'),
      tags: [t('news.tags.internationalForum'), t('news.tags.peaceBuilding'), t('news.tags.ai')],
      image: '/events/summer-meeting-2026-invitation.jpg'
    },
    {
      id: 'first-edition-success',
      title: t('news.firstEdition.title'),
      excerpt: t('news.firstEdition.excerpt'),
      content: t('news.firstEdition.content'),
      publishDate: '2024-09-12',
      author: 'Peja Peace Forum',
      tags: ['2024 Edition', 'Success', 'International Forum', 'Peace Building'],
      image: '/First edition announcement.png'
    },
    {
      id: '1',
      title: t('news.articles.secondEdition.title'),
      excerpt: t('news.articles.secondEdition.excerpt'),
      content: t('news.articles.secondEdition.content'),
      publishDate: '2025-11-05',
      author: t('news.authors.rotaryClub'),
      tags: [t('news.tags.edition2025'), t('news.tags.success'), t('news.tags.internationalForum'), t('news.tags.peaceBuilding')]
    },
    {
      id: '2',
      title: t('news.articles.success2024.title'),
      excerpt: t('news.articles.success2024.excerpt'),
      content: t('news.articles.success2024.excerpt'),
      publishDate: '2024-09-12',
      author: 'Telegrafi',
      tags: ['2024 Edition', 'Success', 'Peace Building'],
      source: 'https://telegrafi.com/en/peace-has-no-alternatives%2C-the-first-edition-of-the-peace-forum-in-Peje-is-considered-successful/'
    },
    {
      id: '3',
      title: t('news.articles.ukraine.title'),
      excerpt: t('news.articles.ukraine.excerpt'),
      content: t('news.articles.ukraine.excerpt'),
      publishDate: '2024-09-11',
      author: 'Telegrafi',
      tags: ['Ukraine', 'International Speakers', 'Resilience'],
      source: 'https://telegrafi.com/en/Stebljanko-at-the-peace-forum-in-Peje%2C-Ukraine-remains-strong-despite-the-economic-losses/'
    },
    {
      id: '4',
      title: t('news.articles.ai.title'),
      excerpt: t('news.articles.ai.excerpt'),
      content: t('news.articles.ai.excerpt'),
      publishDate: '2024-09-11',
      author: 'Telegrafi',
      tags: ['AI', 'Media', 'Journalism'],
      source: 'https://telegrafi.com/en/artificial-intelligence-and-media-influence-hajrullahu-journalism-has-a-decisive-role-in-educating-the-public-about-it/'
    },
    {
      id: '5',
      title: t('news.articles.university.title'),
      excerpt: t('news.articles.university.excerpt'),
      content: t('news.articles.university.excerpt'),
      publishDate: '2024-09-11',
      author: 'Telegrafi',
      tags: ['University', 'Education', 'Academic Impact'],
      source: 'https://telegrafi.com/en/the-rector-of-Haxhi-Zeka-Krasniqi-University%2C-the-conclusions-from-the-peace-forum-are-also-important-for-the-academic-field/'
    },
    {
      id: '6',
      title: t('news.articles.conflictPrevention.title'),
      excerpt: t('news.articles.conflictPrevention.excerpt'),
      content: t('news.articles.conflictPrevention.excerpt'),
      publishDate: '2024-09-11',
      author: 'Telegrafi',
      tags: ['Conflict Prevention', 'Peace Building', 'Community Engagement'],
      source: 'https://telegrafi.com/en/peace-forum-in-Peje-Asllani%2C-our-role-is-to-prevent-conflicts-and-build-peace/'
    },
    {
      id: '7',
      title: t('news.articles.firstEdition.title'),
      excerpt: t('news.articles.firstEdition.excerpt'),
      content: t('news.articles.firstEdition.excerpt'),
      publishDate: '2024-09-11',
      author: 'Telegrafi',
      tags: ['First Edition', 'International Forum', 'Peace Building'],
      source: 'https://telegrafi.com/en/per-te-pare-ne-peje-mbahet-forumi-paqes-teme-ndertimi-paqes-ne-nje-bote-rivaliteti/'
    }
  ];

  const article = allArticles.find(a => a.id === id);

  if (!article) {
    return (
      <div className="article-page">
        <div className="container">
          <div className="article-not-found">
            <h1>{t('common.articleNotFound')}</h1>
            <p>{t('common.articleNotFoundMessage')}</p>
            <a href="/media/news" className="btn btn-primary">
              {t('common.backToNews')}
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="article-page">
      <div className="container">
        <Article article={article} />
      </div>
    </div>
  );
};

export default ArticlePage;
